<template>
    <div class="date-switch">
        <button class="switch-button switch-left" @click="previous">
            <span class="material-icons-round">chevron_left</span>
        </button>
        <button class="switch-button switch-right" :disabled="!canGoNext" @click="next">
            <span class="material-icons-round">chevron_right</span>
        </button>

        <span class="switch-text">{{ dateFormatted }}</span>

        <VButton :label="__('Today')" variant="secondary" size="xs" @onClick="today" />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: null
        },
        allowedMaxDate: {
            type: moment | null,
            required: false,
            default: null
        }
    },
    data() {
        return {
            date: this.value
        }
    },
    computed: {
        dateFormatted() {
            return `${this.date.startOf('isoWeek').format('D. MMMM YYYY')} - ${moment(this.date)
                .add(1, 'week')
                .endOf('week')
                .subtract(2, 'day')
                .format('D. MMMM YYYY')}`
        },
        canGoNext() {
            if (!this.allowedMaxDate) {
                return true
            }

            return moment(this.date).add(2, 'week').isBefore(this.allowedMaxDate)
        }
    },
    methods: {
        previous() {
            this.date = moment(this.date).subtract(2, 'week')
            this.$emit('input', this.date)
        },
        next() {
            if (!this.canGoNext) {
                return
            }

            this.date = moment(this.date).add(2, 'week')
            this.$emit('input', this.date)
        },
        today() {
            this.date = moment()
            this.$emit('input', this.date)
        }
    }
}
</script>
